<template>
  <v-dialog v-model="dialog" persistent max-width="1000" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-on="on" v-bind="attrs"><v-icon>mdi-magnify</v-icon></v-btn>
    </template>
    <v-card>
      <v-card-title class="font-weight-bold">{{ title }}</v-card-title>
      <v-card-subtitle>{{ subtitle }}</v-card-subtitle>
      <v-card-text>
        <v-data-table :items="titulos" :headers="headers" :disable-sort="isMobile()" >
          <template v-slot:[`item.emissao`]="{ item }">
            {{ formatarData(item.emissao) }}
          </template>

          <template v-slot:[`item.vcto`]="{ item }">
            {{ formatarData(item.vcto) }}
          </template>

          <template v-slot:[`item.valor`]="{ item }">
            {{ formatarMoeda(item.valor) }}
          </template>

          <template v-slot:[`item.saldo`]="{ item }">
            {{ formatarMoeda(item.saldo) }}
          </template>

          <template v-slot:[`item.juros`]="{ item }">
            {{ formatarMoeda(item.juros) }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" text rounded :block="isMobile()" color="secondary">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { formatMoeda } from "@/global";

export default {
  props: {
    title: String,
    subtitle: String,
    titulos: Array,
  },
  data: () => ({
    dialog: false,
    headers: [
      { text: "Filial", value: "filial" },
      { text: "Cta", value: "descconta" },
      { text: "Emissão", value: "emissao" },
      { text: "Documento", value: "documento" },
      { text: "Vcto", value: "vcto" },
      { text: "Tipo", value: "tipo" },
      { text: "Valor", value: "valor" },      
      { text: "Juros", value: "juros" },
      { text: "Saldo", value: "saldo" },
    ],
  }),
  methods: {
    isMobile(){
      return this.$mq == 'sm'
    },
    formatarData(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    formatarMoeda(value) {
      return formatMoeda(value);
    },
  },
};
</script>

<style>
</style>